import _ from 'lodash';
import Vue from 'vue';
import Router from 'vue-router';

import auth from './auth';

import Home from 'view/home.vue';
import defaultLayout from './layouts/side-nav-outer-toolbar.vue';
import easyCreativeLayout from './layouts/easy-creative.vue';
import noMenuLayout from './layouts/side-nav-outer-toolbar-no-menu.vue';
import simpleLayout from './layouts/single-card.vue';
import ProposalsList from 'view/proposal/List.vue';
import ProposalBuilder from 'view/proposal/Builder.vue';
import Dashboard from 'view/dashboard/Dashboard.vue';
import LogsDashboard from 'view/logs/Dashboard.vue';
import AirtimeLog from 'view/logs/AirtimeLog.vue';
import CampaignsList from 'view/campaign/List.vue';
import EventRulesList from 'view/schedule/ScheduleEventRules.vue';
import CampaignsDetail from 'view/campaign/Detail.vue';
import DashboardList from 'view/dashboard/List.vue';
import WebServiceStructureBuilder from 'view/webServiceCaller/StructureBuilder.vue';
import WebServiceList from 'view/webServiceCaller/List.vue';
import CreativesList from 'view/creative/List.vue';
import CreativesDetail from 'view/creative/Detail.vue';
import CreativesValidation from 'view/creative/Validation.vue';
import CreativeApprove from 'view/creative/CreativeApprove.vue';
import CreativePersonalizedAd from 'view/creative/PersonalizedAd.vue';
import AiScriptBuilder from 'view/creative/AiScriptBuilder/index.vue';
import ScheduleEditor from 'view/schedule/ScheduleEditor.vue';
import StationList from 'view/station/List.vue';
import StationDetail from 'view/station/Detail.vue';
import UserProfile from 'view/user/Profile.vue';
import TermsAndConditions from 'view/user/TermsAndConditions.vue';
import PrivacyPolicy from 'view/user/PrivacyPolicy.vue';
import CompanyProfile from 'view/company/CompanyProfile.vue';
import LicenseRequests from 'view/user/LicenseRequests.vue';
import InvoicesList from 'view/invoice/List.vue';
import RadioCampaigns from 'view/reconciliation/RadioCampaigns.vue';
import StationsLog from 'view/reconciliation/StationsLog.vue';
import AdminLocalization from 'view/admin/localization';
import GeoTargetsList from 'view/geoTargets/List.vue';
import ProductsCreativesTemplatesList from 'view/products/creativesTemplates/List';
import EasyCreative from 'view/creative/EasyCreative/EasyCreative.vue';
import EasyCreativeIntegration from 'view/creative/EasyCreative/EasyCreativeIntegration.vue';
import TrainingVideosList from 'view/trainingVideos/List.vue';
import TrainingVideosDetail from 'view/trainingVideos/Detail.vue';
import NetworkShowDetail from 'view/networkShow/Detail.vue';
import NetworkShowList from 'view/networkShow/List.vue';
import NetworkShowAffiliatedShowsList from 'view/networkShow/AffiliatedShowsList.vue';
import AdminDashboard from 'view/logs/AdminDashboard.vue';
import PersistentScheduleList from 'view/persistentSchedule/List.vue';
import PersistentScheduleDetail from 'view/persistentSchedule/Detail.vue';
import PersistentJobList from 'view/persistentJob/List.vue';
import PersistentJobDetail from 'view/persistentJob/Detail.vue';
import AiMusicList from 'view/aiMusic/List.vue';
import VoiceShowcaseLink from 'view/insertion/VoiceShowcaseLink.vue';
import VoiceCreatorList from 'view/voiceCreator/List.vue';
import VoiceCreatorDetail from 'view/voiceCreator/Detail.vue';
import BriefsList from 'view/briefs/List.vue';

Vue.use(Router);

const router = new Router({
	routes: [
		{
			path: '/home',
			name: 'home',
			meta: { requiresAuth: true },
			components: {
				layout: defaultLayout,
				content: Home
			}
		},

		
		{
			path: '/proposal/Builder',
			name: 'proposal-builder',
			meta: { requiresAuth: true },
			components: {
				layout: defaultLayout,
				content: ProposalBuilder
			},
			props: { content: (route) => route.params }
		},

		{
			path: '/dashboard/Details/:quoteNumber',
			name: '/dashboard/Details/:quoteNumber',
			meta: { requiresAuth: true },
			components: {
				layout: defaultLayout,
				content: Dashboard
			}
		},

		{
			path: '/products/creatives/templates/List',
			name: 'products-creatives-templates-list',
			meta: { requiresAuth: true },
			components: {
				layout: defaultLayout,
				content: ProductsCreativesTemplatesList
			}
		},

		{
			path: '/creative/List',
			name: 'creative-list',
			meta: { requiresAuth: true },
			components: {
				layout: defaultLayout,
				content: CreativesList
			}
		},

		{
			path: '/creative/Detail/:creativeId',
			name: 'creative-detail',
			meta: { requiresAuth: true, allowAnonym: true },
			components: {
				layout: defaultLayout,
				content: CreativesDetail
			},
			props: { content: (route) => route.params }
		},

		{
			path: '/personalized-ad',
			name: 'personalized-ad',
			meta: { requiresAuth: true },
			components: {
				layout: simpleLayout,
				content: CreativePersonalizedAd
			},
			props: { content: (route) => _.merge(route.params, route.query) }
		},

		{
			path: '/network-studio/shows',
			name: 'network-studio-shows',
			meta: { requiresAuth: true },
			components: {
				layout: defaultLayout,
				content: NetworkShowList
			},
			props: { content: (route) => _.merge(route.params, route.query) }
		},

		{
			path: '/network-shows',
			name: 'network-shows',
			meta: { requiresAuth: true },
			components: {
				layout: defaultLayout,
				content: NetworkShowAffiliatedShowsList
			},
			props: { content: (route) => _.merge(route.params, route.query) }
		},

		{
			path: '/network-studio/show/:id',
			name: 'network-studio-show',
			meta: { requiresAuth: true },
			components: {
				layout: defaultLayout,
				content: NetworkShowDetail
			},
			props: { content: (route) => _.merge(route.params, route.query) }
		},
		
		{
			path: '/easy-creative',
			name: 'easy-creative',
			meta: { requiresAuth: true, allowAnonym: true },
			components: {
				layout: easyCreativeLayout,
				content: EasyCreative
			},
			props: { content: (route) => _.merge(route.params, route.query) }
		},

		{
			path: '/easy-creative/:apiKey',
			name: 'easy-creative-api-key',
			meta: { requiresAuth: true, allowAnonym: true },
			components: {
				layout: easyCreativeLayout,
				content: EasyCreative
			},
			props: { content: (route) => _.merge(route.params, route.query) }
		},

		{
			path: '/easy-creative-integration',
			name: 'easy-creative-integration',
			meta: { requiresAuth: false },
			components: {
				layout: easyCreativeLayout,
				content: EasyCreativeIntegration
			},
			props: { content: (route) => _.merge(route.params, route.query) }
		},

		{
			path: '/Validation/:creativeId',
			name: 'creative-validation',
			meta: { requiresAuth: true, allowAnonym: true },
			components: {
				layout: noMenuLayout,
				content: CreativesValidation
			},
			props: { content: (route) => route.params }
		},

		{
			path: '/Approval/:creativeApprovalId',
			name: 'creative-approve',
			meta: { requiresAuth: true, allowAnonym: true },
			components: {
				layout: noMenuLayout,
				content: CreativeApprove
			},
			props: { content: (route) => _.merge(route.params, route.query) }
		},

		{
			path: '/creative/Publish/:creativeId',
			name: 'creative-publish',
			meta: { requiresAuth: true },
			components: {
				layout: simpleLayout,
				content: CreativesDetail
			},
			props: { content: (route) => route.params }
		},

		{
			path: '/creative/upload-to-track/:creativeId',
			name: 'creative-upload-to-track',
			meta: { requiresAuth: true, allowAnonym: true },
			components: {
				layout: simpleLayout,
				content: CreativesDetail
			},
			props: { content: (route) => route.params }
		},

		{
			path: '/creative/ScriptBuilder',
			name: 'script-builder',
			meta: { requiresAuth: true },
			components: {
				layout: defaultLayout,
				content: AiScriptBuilder
			},
			props: { content: (route) => _.merge(route.params, route.query) }
		},

		{
			path: '/campaign/Details/:campaignId/AdRotation',
			name: '/campaign/Details/:campaignId/AdRotation',
			meta: { requiresAuth: true },
			components: {
				layout: defaultLayout,
				content: ScheduleEditor
			}
		},

		{
			path: '/dashboard/List',
			name: 'dashboard/List',
			meta: { requiresAuth: true },
			components: {
				layout: defaultLayout,
				content: DashboardList
			}
		},

		{
			path: '/logs/Dashboard',
			name: 'logs/Dashboard',
			meta: { requiresAuth: true },
			components: {
				layout: defaultLayout,
				content: LogsDashboard
			},
			props: { content: (route) => _.merge(route.params, route.query) }
		},

		{
			path: '/logs/AdminDashboard',
			name: 'logs/AdminDashboard',
			meta: { requiresAuth: true },
			components: {
				layout: defaultLayout,
				content: AdminDashboard
			},
			props: { content: (route) => _.merge(route.params, route.query) }
		},

		{
			path: '/logs/Airtime',
			name: 'logs/Airtime',
			meta: { requiresAuth: true },
			components: {
				layout: defaultLayout,
				content: AirtimeLog
			},
			props: { content: (route) => _.merge(route.params, route.query) }
		},

		{
			path: '/campaign/List',
			name: '/campaign/List',
			meta: { requiresAuth: true },
			components: {
				layout: defaultLayout,
				content: CampaignsList
			},
			props: { content: (route) => _.merge(route.params, route.query, { type: 1 }) }
		},

		{
			path: '/proposal/List',
			name: '/proposal/List',
			meta: { requiresAuth: true },
			components: {
				layout: defaultLayout,
				content: CampaignsList
			},
			props: { content: (route) => _.merge(route.params, route.query, { type: 0 }) }
		},

		{
			path: '/campaign/List',
			name: '/campaign/List',
			meta: { requiresAuth: true },
			components: {
				layout: defaultLayout,
				content: CampaignsList
			},
			props: { content: (route) => _.merge(route.params, route.query) }
		},

		{
			path: '/campaign/Detail/:id',
			name: 'campaign-detail',
			meta: { requiresAuth: true },
			components: {
				layout: defaultLayout,
				content: CampaignsDetail
			},
			props: { content: (route) => _.merge(route.params, route.query) }
		},

		{
			path: '/training-videos',
			name: '/training-videos',
			meta: { requiresAuth: true },
			components: {
				layout: defaultLayout,
				content: TrainingVideosList
			},
			props: { content: (route) => _.merge(route.params, route.query) }
		},

		{
			path: '/training-videos/:id',
			name: '/training-videos/:id',
			meta: { requiresAuth: true },
			components: {
				layout: defaultLayout,
				content: TrainingVideosDetail
			},
			props: { content: (route) => _.merge(route.params, route.query) }
		},

		{
			path: '/voice-creator',
			name: 'voice-creator',
			meta: { requiresAuth: true },
			components: {
				layout: defaultLayout,
				content: VoiceCreatorList
			},
			props: { content: (route) => _.merge(route.params, route.query) }
		},

		{
			path: '/voice-creator/:id',
			name: 'voice-creator-detail',
			meta: { requiresAuth: true },
			components: {
				layout: defaultLayout,
				content: VoiceCreatorDetail
			},
			props: { content: (route) => _.merge(route.params, route.query) }
		},

		{
			path: '/briefs',
			name: 'briefs',
			meta: { requiresAuth: true },
			components: {
				layout: defaultLayout,
				content: BriefsList
			},
			props: { content: (route) => _.merge(route.params, route.query) }
		},

		{
			path: '/proposal/Detail/:id',
			name: 'proposal-detail',
			meta: { requiresAuth: true },
			components: {
				layout: defaultLayout,
				content: CampaignsDetail
			},
			props: { content: (route) => _.merge(route.params, route.query) }
		},

		{
			path: '/eventRules/List',
			name: '/eventRules/List',
			meta: { requiresAuth: true },
			components: {
				layout: defaultLayout,
				content: EventRulesList
			}
		},

		{
			path: '/wbs/Builder/:id',
			name: 'wbs/Builder/:id',
			meta: { requiresAuth: true },
			components: {
				layout: defaultLayout,
				content: WebServiceStructureBuilder
			},
			props: { content: (route) => route.params }
		},

		{
			path: '/wbs/List',
			name: 'wbs/List',
			meta: { requiresAuth: true },
			components: {
				layout: defaultLayout,
				content: WebServiceList
			}
		},

		{
			path: '/station/List',
			name: 'station-list',
			meta: { requiresAuth: true },
			components: {
				layout: defaultLayout,
				content: StationList
			}
		},

		{
			path: '/station/Detail/:id',
			name: 'station-detail',
			meta: { requiresAuth: true },
			components: {
				layout: defaultLayout,
				content: StationDetail
			},
			props: { content: (route) => route.params }
		},

		{
			path: '/quote-proposal/List',
			name: 'quote-proposal-list',
			meta: { requiresAuth: true },
			components: {
				layout: defaultLayout,
				content: ProposalsList
			}
		},

		{
			path: '/persistent-schedule/List',
			name: 'persistent-shedule-list',
			meta: { requiresAuth: true },
			components: {
				layout: defaultLayout,
				content: PersistentScheduleList
			}
		},

		{
			path: '/persistent-schedule/Detail/:id',
			name: 'persistent-shedule-detail',
			meta: { requiresAuth: true },
			components: {
				layout: defaultLayout,
				content: PersistentScheduleDetail
			},
			props: { content: (route) => route.params }
		},

		{
			path: '/persistent-job/List',
			name: 'persistent-job-list',
			meta: { requiresAuth: true },
			components: {
				layout: defaultLayout,
				content: PersistentJobList
			}
		},

		{
			path: '/persistent-job/Detail/:id',
			name: 'persistent-job-detail',
			meta: { requiresAuth: true },
			components: {
				layout: defaultLayout,
				content: PersistentJobDetail
			},
			props: { content: (route) => route.params }
		},

		{
			path: '/voices-showcase',
			name: 'voices-showcase',
			meta: { requiresAuth: true },
			components: {
				layout: defaultLayout,
				content: VoiceShowcaseLink
			},
			props: { content: (route) => route.params }
		},

		{
			path: '/speech-to-text-manager',
			name: 'speech-to-text-manager',
			meta: { requiresAuth: true },
			components: {
				layout: defaultLayout,
				content: () =>
					import(/* webpackChunkName: 'speechToTextManager' */ 'view/speechToTextManager/index.vue')
			},
			props: { content: (route) => route.params }
		},

		{
			path: '/login-form',
			name: 'login-form',
			meta: { requiresAuth: false, allowAnonym: true },
			components: {
				layout: simpleLayout,
				// route level code-splitting
				// this generates a separate chunk (login.[hash].js) for this route
				// which is lazy-loaded when the route is visited.
				content: () =>
					import(/* webpackChunkName: 'login' */ 'view/login-form.vue')
			},
			props: { content: (route) => route.params }
		},

		{
			path: '/profile',
			name: 'user-profile',
			meta: { requiresAuth: true },
			components: {
				layout: defaultLayout,
				content: UserProfile
			}
		},

		{
			path: '/licenses',
			name: 'licenses',
			meta: { requiresAuth: true },
			components: {
				layout: defaultLayout,
				content: LicenseRequests
			}
		},

		{
			path: '/invoice/List',
			name: '/invoice/List',
			meta: { requiresAuth: true },
			components: {
				layout: defaultLayout,
				content: InvoicesList
			}
		},

		{
			path: '/geo-targets/List',
			name: '/geo-targets/List',
			meta: { requiresAuth: true },
			components: {
				layout: defaultLayout,
				content: GeoTargetsList
			}
		},

		{
			path: '/company/profile',
			name: 'company-profile',
			meta: { requiresAuth: true },
			components: {
				layout: defaultLayout,
				content: CompanyProfile
			},
			props: { content: (route) => _.merge(route.params, route.query) }
		},

		{
			path: '/admin/localization',
			name: 'admin-localization',
			meta: { requiresAuth: true, adminOnly: true },
			components: {
				layout: defaultLayout,
				content: AdminLocalization,
			}
		},

		{
			path: '/reconciliation/radio-campaigns',
			name: 'RadioCampaigns',
			meta: { requiresAuth: true },
			components: {
				layout: defaultLayout,
				content: RadioCampaigns
			}
		},

		{
			path: '/reconciliation/stations-log',
			name: 'StationsLog',
			meta: { requiresAuth: true },
			components: {
				layout: defaultLayout,
				content: StationsLog
			},
			props: { content: (route) => _.merge(route.params, route.query) }
		},

		{
			path: '/ai-music/List',
			name: 'AiMusicList',
			meta: { requiresAuth: true },
			components: {
				layout: defaultLayout,
				content: AiMusicList
			},
			props: { content: (route) => _.merge(route.params, route.query) }
		},

		{
			path: '/terms',
			name: 'terms',
			meta: { requiresAuth: false },
			components: {
				layout: defaultLayout,
				content: TermsAndConditions
			}
		},

		{
			path: '/privacy',
			name: 'privacy',
			meta: { requiresAuth: false },
			components: {
				layout: defaultLayout,
				content: PrivacyPolicy
			}
		},

		{
			path: '/recovery',
			name: 'recovery',
			meta: { requiresAuth: false },
			components: {
				layout: simpleLayout,
				// route level code-splitting
				// this generates a separate chunk (login.[hash].js) for this route
				// which is lazy-loaded when the route is visited.
				content: () =>
					import(/* webpackChunkName: 'recovery' */ 'view/user/RecoveryPassword.vue')
			},
			props: { content: (route) => route.params }
		},

		{
			path: '/pay',
			name: 'pay',
			meta: { requiresAuth: false },
			components: {
				layout: simpleLayout,
				// route level code-splitting
				// this generates a separate chunk for this route
				// which is lazy-loaded when the route is visited.
				content: () =>
					import(/* webpackChunkName: 'pay' */ 'view/invoice/InvoicePayment.vue')
			},
			props: { content: (route) => _.merge(route.params, route.query) }
		},

		{
			path: '/',
			redirect: '/home'
		},
		{
			path: '/recovery',
			redirect: '/home'
		},
		{
			path: '*',
			redirect: '/home'
		}
	]
});

router.beforeEach((to, from, next) => {
	if (__DEBUG__)
		console.debug('Router before each', { to, from, next });

	// change page title from meta
	// Config.getVueApp()
	const appTitle = 'Adthos Platform';
	const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);
	// document.title = appTitle + (nearestWithTitle ? ': ' + nearestWithTitle.meta.title : '');
	document.title = nearestWithTitle ? nearestWithTitle.meta.title : appTitle;

	if (to.name === 'login-form' && auth.authenticated()) {
		next({ name: 'home' });
	} else if (to.matched.some(record => record.meta.adminOnly) && !auth.isAdmin()) {
		next({ name: 'home' });
	} else if (!to.matched.some(record => record.meta.allowAnonym) && auth.isAnonym()) {
		auth.logOut();
		next({
			name: 'login-form',
			query: { redirect: to.fullPath, publicationSession: to.query?.publicationSession }
		});
	} else if (to.matched.some(record => record.meta.requiresAuth)) {
		if (!auth.authenticated()) {
			next({
				name: 'login-form',
				query: { redirect: to.fullPath, authToken: to.query?.authToken || to.query?.auth, publicationSession: to.query?.publicationSession }
			});
		} else {
			const hasRestrictedAccess = !auth.isWorkingOnBehalfOfCompany() || auth.restrictedAccess().includes(to.name);
			if (!hasRestrictedAccess) {
				next({ name: 'home' });
			} else {
				next();
			}
		}
	} else {
		next();
	}
});

export default router;
